const mutations = {
  fileNumber: 'SET_FILENUMBER',
  appraisalAmount: 'SET_APPRAISALAMOUNT',
  invoiceAmount: 'SET_INVOICEAMOUNT'
}

/**
 * Set inmobilized data list
 * @param {Array} payaload - List of Inmobilized Data Objects.
 */
export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(payload)) reject(new Error(`${payload} must be an array`))
    Promise.all([
      new Promise(resolve => resolve(true)),
      payload.map(dc => dispatch('addItem', { ...dc }))
    ]).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

/**
 * Add inmobilized data 
 * @param {Object} payaload - Inmobilized Data Object.
 */
export const addItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    commit('ADD', payload)
    resolve()
  })
}

export const removeItem = ({ commit }, key) => {
  return new Promise((resolve) => {
    commit('DELETE', key)
    resolve()
  })
}

/**
 * Update inmobilized data 
 * @param {Object} payaload - Inmobilized Data Object.
 */
export const updateItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    let key = payload.key
    Object().keys(payload).filter(k => k !== 'key')
    .forEach(param => {
      commit(mutations[param], { key, param, value: payload[param] })
    })
    resolve()
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map((key) => {
        return dispatch('removeItem', key)
      })
    ]).then(() => {
      resolve()
    })
  })
}
